<template>
	<section class="fac-tab-content" :class="status ? 'active' : '' ">
		<!-- @slot Para inserir o conteúdo do card -->
		<slot></slot>
	</section>
</template>

<script>
	export default {
		name: 'ui-card-tab-content',
		props: {
            id: {
				type: String,
				required: true,
			},
        },
		data() {
            return {
				current: null,
				status: false
            }
		},
		methods: {
			check(current){
				if(current === this.id){
					this.status = true
					return 
				}
				this.status = false
			}
		},
		mounted(){
			this.$parent.$on("current", this.check)
		}
    };
</script>